export const determineMainPath = (pathname: string) => {
  let mainPath = '/';
  if (pathname) {
    mainPath = `/${pathname.split('/')[1]}`;
  }
  return mainPath;
};
